import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { Input } from "../../../common/components/Input/Input";

export function EditableTitle({
  value,
  placeholder,
  onChange,
  variant = "subtitle2",
}: {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  variant?: "subtitle2" | "h2" | "h1";
}) {
  const [editing, setEditing] = useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  if (editing) {
    return (
      <Input
        inputRef={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => setEditing(false)}
        onKeyDown={(e) => {
          if (e.key === "Enter") setEditing(false);
        }}
        noMaxWidth
        sx={{ flex: 1, mr: 2 }}
        placeholder={placeholder}
      />
    );
  }

  return (
    <Typography
      variant={variant}
      onClick={() => setEditing(true)}
      sx={{
        flex: 1,
        mr: 2,
        cursor: "pointer",
        py: 0.5,
        "&:hover": { color: "primary.main" },
      }}
    >
      {value || placeholder}
    </Typography>
  );
}
